import Vue from 'vue'

export default function loader (Nesteed, props) {
  return Vue.component('router.loader', {
    render (createElement) {
      return createElement(Nesteed, { props: props(this) })
    }
  })
}
